export const stackOptions = {
  stackable: 0,
  nonStackable: 1
}

export const promotionTypes = {
  applySelectedItem: 0,
  minimumOrder: 1,
  totalOrder: 2,
  freeItem: 3,
  deliveryFree: 4,
  discountNextItem: 5
}

export const orderPromotionTypes = {
  price: 0,
  item: 1,
  deliveryOverride: 2,
  minimumOrderOverride: 3
}

export const promotionAppliedOnTypes = {
  pickup: 0,
  delivery: 1,
  both: 2
}

const itemPromotionTypes = [promotionTypes.freeItem, promotionTypes.discountNextItem]
export const isItemPromotion = (type) => itemPromotionTypes.some(t => t === type)

// Use only valid promotions and get selectedItems from orderItems
export const appendSelectedItems = (promotions, orderPromotions, orderItems) =>
  (promotions || []).filter((promotion) => (orderPromotions || []).some((orderPromo) => orderPromo.promotionReference === promotion.id))
    .map((promotion) => ({
      ...promotion,
      selectedItems: (orderItems || [])
        .filter((orderItem) => orderItem.isPromotionalItem && orderItem.promotionReference === promotion.id)
        .map((orderItem) => ({ ...orderItem, id: orderItem.id }))
    }))
